import { combineReducers } from 'redux';
import errorsReducer from './errorsReducer';
import sidedrawerReducer from './sidedrawerReducer';

export default combineReducers({
	errors: errorsReducer,
	sideDrawer: sidedrawerReducer
});
